import SlackLinkPage from '@gokrew/ui/components/SlackLinkPage';
import { linkSlackAccount } from '@/api/slack-link';
import { useEmployeePortalAuth } from '@/context/EmployeeAuthContext';
import { getUserInitials } from '@gokrew/ui/utility/utility';
import { companyDisplayName } from '@gokrew/ui/utility/companyDisplayName';

export default function EmployeeSlackLinkPage() {
  const { user } = useEmployeePortalAuth();

  const companyLogoUrl = user?.company?.logo ?? null;
  const companyName = companyDisplayName(user?.company) || null;
  const userAvatarUrl = user?.user?.profileImage ?? null;
  const userInitials = user
    ? getUserInitials({
        firstName: user.user.firstName,
        lastName: user.user.lastName,
      })
    : null;

  return (
    <SlackLinkPage
      onLink={linkSlackAccount}
      dashboardPath="/dashboard"
      companyName={companyName}
      companyLogoUrl={companyLogoUrl}
      userAvatarUrl={userAvatarUrl}
      userInitials={userInitials}
    />
  );
}
